import { TaskState } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@enums/task-state.enum';

/** Onglet « Archives » : ce qui est fait, passé ou annulé (A2). */
export const ARCHIVED_TASK_STATES = [TaskState.DONE, TaskState.SKIP, TaskState.CANCELED];

/** Trois articles sous les tâches, puis « Voir tous » : vingt noyaient la liste. */
export const AGENDA_ARTICLES_COUNT = 3;
